import * as types from './types';
import * as _ from 'lodash';

const INITIAL_STATE = {
  configData: null,
  fetching: false,
  fetchError: null,
  submitting: false,
  submitted: false,
  submitError: null,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.VENDOR_ELE_FILE_CONFIG_FETCHING:
      return {
        ...state,
        fetching: payload,
      };
    case types.VENDOR_ELE_FILE_CONFIG_FETCH:
      return {
        ...state,
        configData: payload.configData,
        fetching: false,
      };
    case types.VENDOR_ELE_FILE_CONFIG_FETCH_ERROR:
      if (_.has(payload, 'response.data.Error')) {
        const fetchError = payload.response.data.Errors[0];
        return {
          ...state,
          fetchError,
        };
      } else {
        return {
          ...state,
          fetchError: {
            Title: 'Error',
            Message:
              'An error occurred while fetching the electronic file configuration. Please try again',
          },
        };
      }
    case types.VENDOR_ELE_FILE_CONFIG_SUBMITTING:
      return {
        ...state,
        submitting: payload,
      };
    case types.VENDOR_ELE_FILE_CONFIG_SUBMIT:
      return {
        ...state,
        submitted: true,
      };
    case types.VENDOR_ELE_FILE_CONFIG_SUBMIT_ERROR:
      if (_.has(payload, 'response.data.Errors')) {
        const submitError = payload.response.data.Errors[0];

        return {
          ...state,
          submitError,
        };
      }
      return {
        ...state,
        submitError: {
          Title: 'Error',
          Message:
            'An error occurred while saving the electronic file configuration. Please try again',
        },
      };
    case types.VENDOR_ELE_FILE_CONFIG_CLEAR_ERROR_SUCCESS:
      return {
        ...state,
        fetchError: null,
        fetching: false,
        submitting: false,
        submitted: false,
        submitError: null,
      };
    case types.VENDOR_ELE_FILE_CONFIG_CLEAR_DATA:
      return {
        ...state,
        configData: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/state/eleFileConfig/reducer.js